import React from "react";
import PropTypes from "prop-types";

// core components
import BatchTitle from "./BatchTitle";
import BatchFilterMenu from "./BatchFilterMenu";

// component
export const BatchCollection = ({
    batch,
    batchCollection,
    BatchGridComponent,
    hasMultipleCollections
}) => {
    const { title, filter, uploadIds = [] } = batchCollection;

    const hasFilter = Object.keys(filter).length > 0;

    return (
        <div className="BatchCollection" data-testid="batch-collection">
            {hasMultipleCollections && <BatchTitle text={title} />}
            {hasFilter && <BatchFilterMenu filterData={filter} />}
            <BatchGridComponent batch={batch} uploadIds={uploadIds} />
        </div>
    );
};

export default BatchCollection;

// prop-types
const batchCollectionShape = {
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    filter: PropTypes.object.isRequired,
    uploadIds: PropTypes.array
};

BatchCollection.propTypes = {
    batch: PropTypes.object.isRequired,
    batchCollection: PropTypes.shape(batchCollectionShape).isRequired,
    BatchGridComponent: PropTypes.elementType.isRequired,
    hasMultipleCollections: PropTypes.bool.isRequired
};
